import classNames from 'classnames';

import { TableComponentInterface } from '@/src/assets/interfaces/tablePTInterface';

import styles from './TablePTComponent.module.scss';

const TablePTComponent = ({ value }: TableComponentInterface) => {
    return (
        <figure className={styles.postContentTableBlock}>
            <table className={styles.postContentTable}>
                <tbody>
                    {value.rows.map((row: any, index: number) => {
                        if (index === 0) {
                            return (
                                <tr key={index}>
                                    {row.cells.map((cell: any, index: number) => {
                                        return (
                                            <th
                                                key={index}
                                                className={classNames(
                                                    styles.postContentTable__cell,
                                                    styles[`postContentTable__cell--head`]
                                                )}>
                                                {cell}
                                            </th>
                                        );
                                    })}
                                </tr>
                            );
                        }
                        return (
                            <tr key={index}>
                                {row.cells.map((cell: any, index: number) => {
                                    return (
                                        <td key={index} className={styles.postContentTable__cell}>
                                            {cell}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </figure>
    );
};

export { TablePTComponent };
